import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const ObservationsTableStyled = styled.div`
  @media print {
    && {
      padding: 30px 24px!important;
    }
    .header-table {
      background: ${colors.white}!important;
      -webkit-print-color-adjust: exact;

      p {
        color: ${colors.white}!important;
      }
    }
    .wrap-table {
    }
    .row-add {
      display: none;
    }
  }

  && {
    border-radius: 8px;
    padding: 30px 0;

    .title-table {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      color: ${colors.black};
      margin-bottom: 15px;
    }

    p {
      font-size: 14px;
      line-height: 20px;
      position: relative;
    }

    /* Cabecera y filas de la DataTable de Velora: 14/400, cabecera de 56 px */
    .header-table {
      background: ${tokens.color.background.light};
      border-radius: 16px 16px 0 0;
      padding: 0 16px;
      height: 56px;
      align-items: center;

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        text-align: inherit;
        color: ${tokens.color.text.secondary};
        margin-bottom: 0;
      }
    }

    .wrap-table {
      padding: 0 16px;
      background:${colors.white}
    }

    .row-table {
      border-top: 1px solid ${tokens.color.border.subtle};
      min-height: 64px;
      padding: 8px 0;

      :first-child {
        border-top: 0;
      }

      /* Celdas a 13 px, un punto por debajo de la cabecera */
      p {
        margin-bottom: 0;
        font-weight: 400;
        font-size: 13px;
        line-height: 20px;
        color: ${tokens.color.text.secondary};
      }
    }

    .row-add {
      p,
      .image-bg {
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        color: ${tokens.color.text.disabled};
      }

      .add-button {
        margin-left: 5px;
        text-transform: inherit;
        height: 40px;
        padding: 9px 20px;
        border-radius: 4px;
        color: ${colors.white}
      }
    }
  }
`

const MailSvgStyled = styled.a`
  svg {
    cursor: pointer;
    vertical-align: middle;
    display: inline-block;
    margin-left: 0.5em;
  }
`

export {ObservationsTableStyled, MailSvgStyled}
